import { signOut } from "firebase/auth";
import { projectAuth } from "../firebase/config";
import store from "../store";
import { resolveAccountContext, applyAccountContextToStore } from "./accountContext";
import getUserDocument from "./getUserDocument";
import { applySubscriptionEntitlements } from "./subscriptionEntitlements";

let bootQueue = Promise.resolve();

export function resetBootstrapAuthQueue() {
  bootQueue = Promise.resolve();
}

/**
 * Resolves account context, applies it to the store, and loads the owner user document.
 * Serialized so concurrent onAuthStateChanged handlers (main.js + getUser) share one run.
 */
export function bootstrapAuthSession(authUser) {
  if (!authUser?.uid) {
    return Promise.resolve(false);
  }

  const run = async () => {
    if (
      store.state.infoLoaded &&
      store.state.authUser?.uid === authUser.uid &&
      store.state.currentUser?.uid
    ) {
      return true;
    }

    const context = await resolveAccountContext(authUser);
    if (context?.status === "suspended") {
      await signOut(projectAuth);
      return false;
    }
    applyAccountContextToStore({
      authUser,
      context,
      store,
    });
    await getUserDocument(context.ownerUid || authUser.uid);
    applySubscriptionEntitlements(store, store.state.userConfig || {});
    store.state.loggedIn = true;
    store.state.infoLoaded = true;
    return true;
  };

  const next = bootQueue.then(() => run());
  bootQueue = next.catch(() => {});
  return next;
}
